var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('v-row',{staticClass:"py-6",attrs:{"justify":"center"}},[_c('v-img',{attrs:{"src":require("../assets/tmx-logo-h100.png"),"max-width":"160px"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }